import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CHeader, CToggler, CHeaderBrand, CHeaderNav, CImg } from '@coreui/react';
import CIcon from '@coreui/icons-react';

import logo from '../assets/images/logo.png';
import GlobalSelections from '../Features/GlobalSelections';
import ToggleDropdown from '../Shared/ToggleDropdown/ToggleDropdown';
import ShareReportButton from '../Features/Reports/ShareReportButton';

const TheHeader = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const darkMode = useSelector((state) => state.base.darkMode);
  const sidebarShow = useSelector((state) => state.base.sidebarShow);
  const toggleSidebar = () => {
    const val = [true, 'responsive'].includes(sidebarShow) ? false : 'responsive';
    dispatch({ type: 'set', sidebarShow: val });
  };

  const toggleSidebarMobile = () => {
    const val = [false, 'responsive'].includes(sidebarShow) ? true : 'responsive';
    dispatch({ type: 'set', sidebarShow: val });
  };

  const onDarkThemeToggle = () => {
    if (darkMode) {
      localStorage.removeItem('dark_mode');
    } else {
      localStorage.setItem('dark_mode', '1');
    }
    dispatch({ type: 'set', darkMode: !darkMode });
  };

  return (
    <CHeader
      withSubheader
      className="d-flex justify-content-between pr-0 pr-md-3 align-items-center"
    >
      <div className="d-flex align-items-center">
        <CToggler inHeader className="ml-md-3 d-lg-none" onClick={toggleSidebarMobile} />
        <CToggler inHeader className="ml-3 d-md-down-none" onClick={toggleSidebar} />
        <CHeaderBrand className="mx-md-auto mx-0 d-lg-none" to="/">
          <div className="logo ivert">
            <CImg height="40px" src={logo} fluid />
            <span className="d-none d-md-inline-block">eQual</span>
          </div>
        </CHeaderBrand>
      </div>
      <div className="d-flex justify-content-between">
        <CHeaderNav className="d-md-down-none mr-auto" />
        <GlobalSelections />
        <CHeaderNav className="px-3 d-none d-lg-flex align-items-center">
          <CToggler
            inHeader
            className="ml-3 d-md-down-none"
            onClick={onDarkThemeToggle}
            title="Toggle Light/Dark Mode"
          >
            <CIcon name="cil-moon" className="c-d-dark-none" alt="CoreUI Icons Moon" />
            <CIcon name="cil-sun" className="c-d-default-none" alt="CoreUI Icons Sun" />
          </CToggler>
          {location.pathname === '/reports' && <ShareReportButton />}
        </CHeaderNav>
        <ToggleDropdown />
      </div>
    </CHeader>
  );
};

export default TheHeader;
